import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { Button } from '../catalyst-ui-kit/button';

// If we failed to fetch product data in /trade/$asset, show a different default
// title. TODO: Don't rely on error string comparison.
const FAILED_TO_FETCH_PRODUCTS = 'Failed to fetch product data';

interface UnexpectedErrorComponentProps {
  error: Error;
  title?: string;
}

export const ErrorPage: React.FC<UnexpectedErrorComponentProps> = ({ error }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isUnableToConnect = error.message.startsWith(FAILED_TO_FETCH_PRODUCTS);
  const title = isUnableToConnect ? 'Unable to connect to exchange.' : 'Unexpected error occurred.';
  const description = isUnableToConnect
    ? "We can't connect to the exchange right now. The team is on it."
    : 'A fix is in progress - thanks for your patience.';

  return (
    <div className="flex grow flex-col items-center justify-center px-4 py-6 text-center">
      <div className="flex max-w-md flex-col items-center gap-6">
        {/* Error Title & Message */}
        <div className="flex flex-col space-y-3">
          <h1 className="text-xl text-contentPrimary">{title}</h1>
          <p className="text-contentSecondary">{description}</p>
        </div>

        {/* Error Details Toggle */}
        <Button plain onClick={() => setIsExpanded(!isExpanded)} className="flex items-center">
          <p className="text-contentSecondary">{isExpanded ? 'Hide' : 'Show'} Error Details</p>
          {isExpanded ? (
            <ChevronUpIcon className="ml-1 size-5" />
          ) : (
            <ChevronDownIcon className="ml-1 size-5" />
          )}
        </Button>

        {/* Error Details */}
        {isExpanded && (
          <div className="relative w-full rounded-md bg-backgroundPrimary p-4 text-left  text-contentSecondary">
            <p className="break-words font-mono text-sm">
              Error: {error.message || 'Unknown error'}
            </p>
          </div>
        )}

        {/* Action Buttons */}
        <div className="mt-4 flex flex-col space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
          <Button href="/" color="blue">
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};
